// Hands the browser a finished background-job file. Five copies of this existed — one in
// packs/customers/index.js, three in packs/quality_controls/index.js and one in laatu.js — all
// building an anchor, clicking it and removing it (F-69).
//
// ⚠️ `newTab` is not cosmetic, and it is why the flag comes from the server. Active Storage's
// `Blob#url` defaults to `disposition: :inline`, and `forced_disposition_for_serving` overrides that
// to `attachment` only for content types outside `ActiveStorage.content_types_allowed_inline` —
// which **includes PDF**. So an xlsx is sent as an attachment and a new tab opens, downloads and
// closes itself, which is the flash the owner reported; a PDF is sent inline and the tab genuinely
// shows it. The content type lives on the blob, so `background_jobs#show` decides and sends
// `open_in_tab`.
export function openDownloadLink(url, { newTab = false } = {}) {
  if (!url) return

  const attributes = { href: url, css: { display: 'none' } }
  if (newTab) {
    attributes.target = '_blank'
    // Without this, the opened tab keeps a reference to window.opener.
    attributes.rel = 'noopener'
  }

  const link = $('<a>', attributes)
  $('body').append(link)
  link[0].click()
  link.remove()
}
